<template>
    <v-card width="560" light elevation="24" :disabled="!isConsole">
        <v-card-title class="font-weight-bold">공휴일정책</v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="pb-0">
                    <v-date-picker v-model="holiday.dates" multiple locale="ko" lang class="text-h6" elevation="4" :allowed-dates="validateDay" @input="sortDate" />
                </v-col>
                <v-col class="pb-0" style="max-height:398px;overflow-y:auto">
                    <v-combobox v-model="holiday.dates" type="date" multiple deletable-chips small-chips filled outlined allow-overflow hide-details @input="sortDate" />
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions v-if="isConsole">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="save">저장</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";

const initialHoliday = {
    _id: undefined,
    dates: [],
};

export default {
    props: {
        value: { type: Boolean, default: false },
    },
    data() {
        return {
            holiday: { ...initialHoliday },
        };
    },
    computed: {
        isConsole() {
            return this.$store.state.scope.includes("console");
        },
    },
    async mounted() {
        await this.search();
    },
    methods: {
        async search() {
            try {
                const { holidays } = await api.console.holidays.getHolidays();
                let holiday = { ...initialHoliday };
                if (holidays.length) holiday = { _id: holidays[0]._id, dates: holidays[0].dates.map((date) => date.split("T")[0]) };
                this.holiday = holiday;
            } catch (error) {
                this.handleError(error);
            }
        },
        async save() {
            try {
                const { holiday } = this;
                await (holiday._id ? api.console.holidays.putHoliday(holiday) : api.console.holidays.postHoliday(holiday));
                alert("공휴일 정책이 설정되었습니다.");
                await this.search();
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
        validateDay(date) {
            switch (dayjs(date).day()) {
                case 0:
                case 6:
                    return false;
                default:
                    return true;
            }
        },
        sortDate(dates) {
            dates.sort((a, b) => dayjs(a).isAfter(dayjs(b))? -1 : 1);
            this.holiday.dates = dates;
        },
    },
    watch: {
        value() {
            if (this.value) this.search();
        },
    },
};
</script>
